import { useContext } from "react";

import { ChatContext } from "../context/ChatContext";

export const useChatContext = () => {
  const context = useContext(ChatContext);

  // NOTE: this guard ensures the hook is used within its required provider and does not need test coverage.
  /* istanbul ignore next */
  if (context === undefined) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }
  return context;
};
